import {
  type Query,
  useQuery,
  type UseQueryResult,
} from "@tanstack/react-query";
import { checkOrderStatus } from "@/api/endpoints/orders";
import type { CheckOrderStatusResponse } from "@/api/types/orders";
import { queryKeys } from "@/lib/queryClient";

export function useCheckOrderStatus(
  checkoutId: string,
  enabled = true,
  refetchInterval?: (
    query: Query<
      CheckOrderStatusResponse,
      Error,
      CheckOrderStatusResponse,
      readonly string[]
    >
  ) => number | false | undefined
): UseQueryResult<CheckOrderStatusResponse, Error> {
  return useQuery({
    queryKey: queryKeys.orders.checkStatus(checkoutId),
    queryFn: () => checkOrderStatus(checkoutId),
    staleTime: 0, // Always fetch fresh data for order status
    enabled: enabled && !!checkoutId, // Only run if enabled and checkoutId exists
    refetchInterval, // Optional polling configuration
    refetchIntervalInBackground: false, // Don't poll in background
  });
}
